import { useCallback, useMemo } from 'react';
import { PostalAddress } from '~/adapters/services/accounts/postalAddresses/types';
import { useAddressUpdate } from '~/adapters/services/accounts/postalAddresses/hooks';
import { addressToFormState, formStateToDto } from '../mappers';
import { AddressDialog } from './AddressDialog';
import { AddressFormState, DialogProps } from '../types';

interface EditAddressDialogProps extends DialogProps {
    address: PostalAddress;
}

export function EditAddressDialog({ open, onClose, address }: EditAddressDialogProps) {
    const initialAddressState = useMemo(() => addressToFormState(address), [address]);

    const { mutateAsync, isLoading } = useAddressUpdate();
    const onSubmit = useCallback(
        (addressState: AddressFormState) => mutateAsync({ id: address.id, addressDto: formStateToDto(addressState) }),
        [address.id, mutateAsync],
    );

    return (
        <AddressDialog
            title="Update Address"
            open={open}
            onClose={onClose}
            initialAddressState={initialAddressState}
            onSubmit={onSubmit}
            isLoading={isLoading}
        />
    );
}
